<div style="width:500px;height:500px; margin:auto; text-align:center; vertical-align:central">
  <br />
  <br />
  <br />
  <br />
  <img src="assets/images/logoext.png" />
  <br />
  <a href="/authentication/login" *ngIf="isDevelopment">login</a>
</div>
